import React, { useState, Fragment } from 'react';
import { Tabs, NavBar, Icon } from 'antd-mobile';
import { useHistory } from 'react-router';
import { getBooleanValue } from '@/utils';

import ConferenceList from '@/busi/saas/conferenceList';
import DrawerWrapper from '@/components/drawerWrapper';

const TabsList =  [
  { title: '名校直播', key: 'mxzb' },
  { title: '名校回看', key: 'mxhk' },
]

const DeptSubList = (props) => {

  const { match: { params: { deptId } } } = props;

  const [selected, setSelected] = useState('mxzb');

  const width = ((100 / 2) * 0.47).toFixed(3);
  const left = (100 / 2).toFixed(3);
  const history = useHistory();
    return (
      <DrawerWrapper >
        <div className="app-layout">
          <NavBar
            mode="light"
            icon={<Icon type="left" />}
            onLeftClick={() => history.goBack()}
            style={
              getBooleanValue('IS_IMMERSE', false) ? { paddingTop: '6vw', height: '18vw' } : null
            }
          >
            名校详情
          </NavBar>
          <div className="app-tabs">
          <Tabs
              tabs={TabsList}
              tabBarPosition="top"
              renderTabBar={(props) => <Tabs.DefaultTabBar {...props} page={2} />}
              page={selected}
              tabBarUnderlineStyle={{
                width: `${width}vw`,
                height: '0.667vw',
                marginLeft: `calc((${left}% - ${width}vw) / 2)`,
                backgroundColor: '#00b4ff',
                borderRadius: '0.333vw',
              }}
              onChange={async (tab) => {
                await setSelected(tab.key);
              }}
            >
              <Fragment>
                {
                  selected === 'mxzb' ?
                    <ConferenceList config={{ conferenceStatus: 1, conferenceType: 2, replayable: 0, deptId }} appCode="excellent-course"/> : null
                }
                {
                  selected === 'mxhk' ?
                    <ConferenceList config={{ conferenceStatus: 2, conferenceType: 2, replayable: 1, deptId }} appCode="excellent-course"/>: null
                }
              </Fragment>
            </Tabs>
          </div>
        </div>
      </DrawerWrapper>
    );
}

export default DeptSubList;
